import React, { useState } from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import MainBk from "../img/viviendas_futuras/7.Fondo-ProyectosFuturo.jpg";
import ImageSantaCruz from "../img/viviendas_futuras/7.Capusla-PF-SantaCruz.png";
import ImageVersalles from "../img/viviendas_futuras/7.Capusla-PF-Versalles.png";
import ImageZarzal from "../img/viviendas_futuras/7.Capusla-PF-Zarzal.png";
import ImagePamplona from "../img/viviendas_futuras/7.Capusla-PF-PAMPLONA2.png";


//Data Display
import TopLeftTitle from "../data_display/TopLeftTitle";
import ButtonLeftTitle from "../data_display/BottomLeftTitle";
import MiniaturePreview from "../data_display/MiniaturePreview";
import PointDefault from "../data_display/PointLocation";

//Inputs
import HomeButton from "../inputs/HomeButton";

//Navigation
import MenuMiniatures from "../navigation/MenuMiniatures";

const listMiniatures = [{
    id: "1",
    title:"480",
    subtitle:"Unidades",
    image: ImageSantaCruz,
    x: "27%",
    y: "33%"
}, {
    id: "2",
    title:"583",
    subtitle:"Unidades",
    image: ImageVersalles,
    x: "38%",
    y: "40%"
}, {
    id: "3",
    title:"480",
    subtitle:"Unidades",
    image: ImageZarzal,
    x: "34%",
    y: "43%"
}, {
    id: "4",
    title:"472",
    subtitle:"Unidades",
    image: ImagePamplona,
    x: "32%",
    y: "50%"
}];

export default function ViviendasFuturasPage () {
    const [currentItem, SetCurrentItem] = useState(0);

    function onClickMiniature(tmpIndex)
    {
        SetCurrentItem(tmpIndex);
    }

    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+MainBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"80px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>
            <TopLeftTitle title={"PROYECTOS A FUTURO"} subtitle={""} />
            <ButtonLeftTitle title={"7.489"} subtitle={"Viviendas Construidas"} />
            <HomeButton/>
            <MiniaturePreview item={listMiniatures[currentItem]}/>
            <MenuMiniatures items={listMiniatures} selected={currentItem} onClick={onClickMiniature}/>
            {
                listMiniatures.map((item, index)=>{
                    return (<PointDefault key={item.id} id={item.id} 
                        x={item.x} y={item.y} index={index}
                        onClick={onClickMiniature}
                        selected={index === currentItem ? true:false}
                        />
                    )
                })
            }
        </div>
    );
}